import { render, staticRenderFns } from "./extra-it-ticket-vorgaben-bearbeiten.vue?vue&type=template&id=5c6afcca&lang=pug&"
import script from "./extra-it-ticket-vorgaben-bearbeiten.vue?vue&type=script&lang=js&"
export * from "./extra-it-ticket-vorgaben-bearbeiten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports